import { Alignment, Layout } from 'components/admin-bridge/EditorModal/ModalComponents/OptionRow/types';
import { MAESTRO_BLACK } from 'style/constants';

export interface IVideoSpotlight {
  alignment: Alignment;
  background: {
    color: string;
    customColor: string;
    image: {
      desktop: string;
      mobile: string;
      show: boolean;
    }
  }
  description: {
    show: boolean;
  }
  layout: Layout;
  playerBehavior: 'inline' | 'videoPage';
  tags: {
    show: boolean;
  }
  title: {
    show: boolean;
  }
  uploadDate: {
    show: boolean;
  }
  // We use the videoId to get the realtime document
  videoId: string;
}

interface IVideoSpotlightItem {
  arrayId: string;
  data: IVideoSpotlight;
  kind: string;
}

export interface IVideoSpotlightProps {
  index: number;
  item: IVideoSpotlightItem;
  onEdit: (item: IVideoSpotlightItem) => void;
  onRemove: () => void;
}

export const DEFAULT_TITLE = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus quam ullamcorper facilisi tortor, leo gravida accumsan, nunc.';
export const DEFAULT_DESCRIPTION = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Arcu, metus, et tortor massa sapien proin. At dignissim amet, ante urna tempus, vitae pellentesque nisi, sit. Justo malesuada nisi, phasellus orci dictumst nunc.';
export const DEFAULT_TAGS = ['loremipsum', 'loremipsum', 'loremipsum', 'loremipsum', 'loremipsum'];
export const DEFAULT_UPLOAD_DATE = '10 Days Ago';

export const DEFAULT_VIDEO_SPOTLIGHT: IVideoSpotlight = {
  videoId: '',
  tags: {
    show: true,
  },
  uploadDate: {
    show: true,
  },
  title: {
    show: true,
  },
  description: {
    show: true,
  },
  background: {
    color: 'surface1',
    customColor: MAESTRO_BLACK,
    image: {
      show: true,
      mobile: 'https://static.gcp.maestro.io/media/607ee3c2619057002d4f1784/64360bd88af2bf00a7d1826b.jpg',
      desktop: 'https://static.gcp.maestro.io/media/607ee3c2619057002d4f1784/64360b94e728e500a7fe198a.jpg',
    },
  },
  alignment: Alignment.Left,
  layout: 'left',
  playerBehavior: 'videoPage',
};
